import { render, staticRenderFns } from "./TemplateSelectManager.vue?vue&type=template&id=5b45e0f4&"
import script from "./TemplateSelectManager.vue?vue&type=script&lang=ts&"
export * from "./TemplateSelectManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports